// CategoryDrawer.jsx
import React from 'react';
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  Box,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

export default function CategoryDrawer({
  open,
  onClose,
  customCategories = [],
  onCreate,
  onDelete,
}) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { minWidth: 360 },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={2}
      >
        <Typography variant="h6">Categorie personalizzate</Typography>
        <IconButton onClick={onClose} aria-label="Chiudi">
          <CloseIcon />
        </IconButton>
      </Box>

      <Box px={2} pb={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={onCreate}
          fullWidth
        >
          Nuova categoria
        </Button>
      </Box>

      <Divider />

      <List dense>
        {customCategories.length > 0 ? (
          customCategories.map((c) => (
            <ListItem key={c.id}>
              <ListItemText primary={c.label} />
              <IconButton
                edge="end"
                onClick={() => onDelete(c)}
                title="Elimina"
              >
                <DeleteIcon />
              </IconButton>
            </ListItem>
          ))
        ) : (
          <ListItem>
            <ListItemText primary="Nessuna categoria personalizzata" />
          </ListItem>
        )}
      </List>
    </Drawer>
  );
}
